module.exports = __webpack_public_path__ + "img/moscow-en.3e6aee6.svg";